<template>
    <div class="LoadOnScroll" v-on:scroll="handleScroll">
        <slot></slot>
    </div>
</template>

<script>
export default {
	methods: {
		handleScroll () {
			let e = event.target
			if (e.scrollTop + e.offsetHeight >= e.scrollHeight) {
				this.$emit('loadMore')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.LoadOnScroll {
    overflow: auto;
    height: 100%;
    width: 100%;
}
</style>
